import localforage from 'localforage'
import shortid from 'shortid';
import { actions, mutations } from '../constants'

const localStorageKeys = {
  LAST_CART_SESSION: 'LAST_CART_SESSION',
};


const cart = {
  state: {
      total: 0,
      items:[]
  },
  mutations: {
    [mutations.CART_ADD_ITEM](state, {id, price, type, recipient, product, service}){
      state.items = [...state.items, {
        id, price, type, recipient, product, service
      }];
      state.total = state.total || 0;
      state.total+=price;
    },
    [mutations.CART_SET_ITEMS](state, items=[]){
      state.items = items;
      state.total = state.total || 0;
      state.total+=items.reduce((acc,val)=>acc+val.price,0);
    },
    [mutations.CART_RESET](state){
      state.items = [];
      state.total = 0;
    },
  },
  actions: {
    [actions.CART_ADD_ITEM]({commit, state, rootState}, {price, type, recipient, product, service}){
        const item = {price, type, recipient, product, service};
        item.id = shortid.generate();
        commit(mutations.CART_ADD_ITEM, item);
        return Promise.resolve(item);
        // return localforage.setItem(`${rootState.auth.user.id}/${localStorageKeys.LAST_CART_SESSION}`, state.items).then(() => {
        //   return Promise.resolve(item)
        // });
    },
    [actions.CART_REMOVE_ITEM]({commit, state, rootState}, {id}){
      const newItems = state.items.filter(i=>i.id!=id);
      commit(mutations.CART_SET_ITEMS, newItems);
      return Promise.resolve(true);
    },

    [actions.CART_RESTORE_LAST_SESSION]({commit, dispatch, state, rootState}){

      return localforage.getItem(`${rootState.auth.user.id}/${localStorageKeys.LAST_CART_SESSION}`)
        .then(items=>{
          if(items && Array.isArray(items)){
            commit(mutations.CART_ADD_ITEMS, items);
          }else{
            return Promise.resolve(false)
          }
        })
        .catch(err=>{
          return Promise.resolve(false)
        })
    },

    [actions.CART_RESET]({commit, dispatch, state, rootState}){
      commit(mutations.CART_RESET);
      return Promise.resolve(true);
      // return localforage.setItem(`${rootState.auth.user.id}/${localStorageKeys.LAST_CART_SESSION}`, []).then(() => {
      //   return Promise.resolve(true)
      // });

    }


  }
};

export default cart;



// WEBPACK FOOTER //
// ./src/store/modules/cart.js